import {StyleSheet} from "aphrodite/no-important"

export const styles = StyleSheet.create({
    
    content: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    },

    trendContainer: {
        display: "grid",
        gridTemplateColumns: "75% 24%",
        gridColumnGap: "10px",
        width: "100%",
        marginTop: "20px",
        marginBottom: "20px",
        alignItems: "center"
    }
});


// WEBPACK FOOTER //
// ./src/components/AuthorCombinedStyles.ts